export default __webpack_public_path__ + "images/7ce1a209009511cf3d6372736e0f428c.webp";